import { useEffect, useState } from "react";
import { BRAND } from "../data/staticData";

export default function LoadingScreen() {
  const [done, setDone] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((p) => {
        const next = p + Math.random() * 40 + 10;
        if (next >= 100) {
          clearInterval(interval);
          setTimeout(() => setDone(true), 250);
          return 100;
        }
        return next;
      });
    }, 60);
    return () => clearInterval(interval);
  }, []);

  if (done) return null;

  return (
    <div
      data-testid="loading-screen"
      className="fixed inset-0 z-[9998] flex flex-col items-center justify-center bg-[#0A0A0A]"
      style={{
        opacity: progress >= 100 ? 0 : 1,
        transition: "opacity 0.4s ease",
        pointerEvents: progress >= 100 ? "none" : "auto",
      }}
    >
      <div className="absolute inset-0 grain-overlay" />
      <div className="relative z-10 flex flex-col items-center gap-6">
        <div className="relative">
          <div className="absolute inset-0 bg-[#7CFF00] blur-3xl opacity-30 animate-pulse" />
          <img
            src={BRAND.logos.primary}
            alt="Frontline Defense"
            className="relative h-48 md:h-72 w-auto drop-shadow-[0_0_40px_rgba(124,255,0,0.55)]"
          />
        </div>
        <div className="overline">// Booting Tactical Systems</div>
        <div className="w-72 h-[2px] bg-white/10 overflow-hidden">
          <div
            className="h-full bg-[#7CFF00]"
            style={{
              width: `${Math.min(100, progress)}%`,
              boxShadow: "0 0 16px rgba(124,255,0,0.7)",
              transition: "width 0.18s linear",
            }}
          />
        </div>
        <div className="font-mono-tactical text-xs text-zinc-500 uppercase tracking-widest">
          {Math.floor(progress)}% — Loading Tactical Systems
        </div>
      </div>
    </div>
  );
}
